import { AppContent } from '@/AppContent';
import { LoaderProvider } from '@/contexts/LoaderContext';
import { SuccessMessageProvider } from '@/shared/contexts/SuccessMessageContext';
import React from 'react';

const App: React.FC = () => (
  <LoaderProvider>
    <SuccessMessageProvider>
      <AppContent />
    </SuccessMessageProvider>
  </LoaderProvider>
);

export { App };
